/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_Review_DescInputs */

const en_mk_team_flow_review_desc = /** @type {(inputs: Mk_Team_Flow_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the evidence, request fixes if needed, and continue according to your approval checkpoints.`)
};

const id_mk_team_flow_review_desc = /** @type {(inputs: Mk_Team_Flow_Review_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat bukti pemeriksaan, minta perbaikan bila perlu, lalu lanjutkan sesuai titik persetujuanmu.`)
};

/**
* | output |
* | --- |
* | "Review the evidence, request fixes if needed, and continue according to your approval checkpoints." |
*
* @param {Mk_Team_Flow_Review_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_review_desc = /** @type {((inputs?: Mk_Team_Flow_Review_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_Review_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_review_desc(inputs)
	return en_mk_team_flow_review_desc(inputs)
});